import { requestType } from '~/config/enum.config';
var SERVICE = 'management-service';
var CONTROLLER = 'resourceController';
export default {
    /**
     * 根据查询所有用户不分页
     */
    getResourceAll: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getResourceAll',
        type: requestType.Get,
    },
    getResourceAllPage: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getResourceAllPage',
        type: requestType.Get,
    },
    createResource: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'createResource',
        type: requestType.Post,
    },
    deleteResourceById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'deleteResourceById',
        type: requestType.Delete,
    },
};
